import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import WirelineLocationFormB from './wireline-location-form-ex-b.component';
import WirelineSubscriptionFormB from './wireline-subscription-form-ex-b.component';
import WirelineBusinessFormB from './wireline-business-form-ex-b.component';
import { newCircuitExhibitBActions } from "./../../../../../../../store/external/request-reducer/order-request-reducer/wireline-request/new-circuit/new-circuit-exhibit-b.reducer";
import { createRequestActions } from "./../../../../../../../store/external/request-reducer/create-request.reducer";
import { fileAttachmentActions } from "./../../../../../../../store/external/common-reducer/file-attachment.reducer";
import Icons from '../../../../../../icon';
import Translation from '../../../../../../common/translation/translation.component';
import { TRANSLATIONS as translation } from '../../../../../../../utils/constant.utils';

class NewCircuitFormExhibitB extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLocationForm: true,
            isSubscriptionForm: false,
            isBusinessForm: false
        }
    }

    componentWillUnmount() {
        this.props.resetNewCircuitForm();
        this.props.resetRequestData();
        this.props.resetFileAttachment();
    }

    nextAction = () => {

        const { isLocationForm, isSubscriptionForm } = this.state;
        const { disableROBCheckbox } = this.props;

        if (isSubscriptionForm) {
            this.setState({
                isLocationForm: false,
                isSubscriptionForm: false,
                isBusinessForm: true
            });
        }
        else if (isLocationForm) {
            this.setState({
                isLocationForm: false,
                isSubscriptionForm: true,
                isBusinessForm: false
            });

            disableROBCheckbox(true);
        }
        else {
            console.log("Submit")
        }
    }

    prevAction = () => {

        const { isSubscriptionForm, isBusinessForm } = this.state;
        const { disableROBCheckbox } = this.props;

        if (isBusinessForm) {
            this.setState({
                isLocationForm: false,
                isSubscriptionForm: true,
                isBusinessForm: false
            });
        }
        else if (isSubscriptionForm) {
            this.setState({
                isLocationForm: true,
                isSubscriptionForm: false,
                isBusinessForm: false
            });

            disableROBCheckbox(false);
        }

    }

    displayForm = () => {
        const { isLocationForm, isSubscriptionForm, isBusinessForm } = this.state;
        let form;

        if (isLocationForm) {
            form = <WirelineLocationFormB onClickCancel={this.onClickCancel} nextAction={this.nextAction} />
        } else if (isSubscriptionForm) {
            form = <WirelineSubscriptionFormB onClickCancel={this.onClickCancel} nextAction={this.nextAction} prevAction={this.prevAction} />
        } else {
            form = <WirelineBusinessFormB onClickCancel={this.onClickCancel} prevAction={this.prevAction} modalMessage={this.props.modalMessage} />
        }

        return (form);
    }

    onClickCancel = () => {
        const { modalClose } = this.props;

        if (modalClose !== null && modalClose !== undefined) {
            modalClose();
        }
    }

    toLocaleLanguage = (key) => {
        const { locale } = this.props;
        if (locale === null || locale === '')
            return translation[translation['defaultLocaleLanguage']][key];

        return translation[locale][key];
    }

    render() {
        const { isLocationForm, isSubscriptionForm, isBusinessForm } = this.state;
        const { modalClose } = this.props;
        let submitLabel = isBusinessForm ? "Submit Request" : "Next";
        return (
            <div>
                <Row>
                    <Col xs={12} md={12} lg={12}>
                        <h6 className="plan-detail-sub-header"><Translation translationKey="order_request_details" /></h6>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={12} lg={12}>
                        {
                            isLocationForm ?
                                // <h5>Location</h5> 
                                <div className="icon-count-container">
                                    <Icons
                                        customClassName="icon-circle-1"
                                        name="circle-1-solid"
                                        labelValue={this.toLocaleLanguage('location')}
                                        size="32px"
                                        containerClass="icon-active-container"
                                    />
                                    <div className="first-vertical-line"></div>
                                    <Icons
                                        customClassName="icon-circle-2"
                                        name="circle-2-solid"
                                        labelValue={this.toLocaleLanguage('subscription')}
                                        size="32px"
                                        containerClass="icon-normal-container"
                                    />
                                    <div className="second-vertical-line"></div>
                                    <Icons
                                        customClassName="icon-circle-3"
                                        name="circle-3-solid"
                                        labelValue={this.toLocaleLanguage('call_business')}
                                        size="32px"
                                        containerClass="icon-normal-container"
                                    />

                                </div>
                                :
                                (isSubscriptionForm ?
                                    //<h5>Subscription</h5> 
                                    <div className="icon-count-container">
                                        <Icons
                                            customClassName="icon-circle-1"
                                            name="circle-1-duo"
                                            labelValue={this.toLocaleLanguage('location')}
                                            size="32px"
                                            containerClass="icon-selected-container"
                                        />
                                        <div className="first-vertical-line"></div>
                                        <Icons
                                            customClassName="icon-circle-2"
                                            name="circle-2-solid"
                                            labelValue={this.toLocaleLanguage('subscription')}
                                            size="32px"
                                            containerClass="icon-active-container"
                                        />
                                        <div className="second-vertical-line"></div>
                                        <Icons
                                            customClassName="icon-circle-3"
                                            name="circle-3-solid"
                                            labelValue={this.toLocaleLanguage('call_business')}
                                            size="32px"
                                            containerClass="icon-normal-container"
                                        />
                                    </div>
                                    :
                                    //  <h5>Business</h5>
                                    <div className="icon-count-container">
                                        <Icons
                                            customClassName="icon-circle-1"
                                            name="circle-1-duo"
                                            labelValue={this.toLocaleLanguage('location')}
                                            size="32px"
                                            containerClass="icon-selected-container"
                                        />
                                        <div className="first-vertical-line"></div>
                                        <Icons
                                            customClassName="icon-circle-2"
                                            name="circle-2-duo"
                                            labelValue={this.toLocaleLanguage('subscription')}
                                            size="32px"
                                            containerClass="icon-selected-container"
                                        />
                                        <div className="second-vertical-line"></div>
                                        <Icons
                                            customClassName="icon-circle-3"
                                            name="circle-3-solid"
                                            labelValue={this.toLocaleLanguage('call_business')}
                                            size="32px"
                                            containerClass="icon-active-container"
                                        />
                                    </div>
                                )
                        }

                    </Col>
                </Row>
                {this.displayForm()}
            </div>
        );
    }
};
export default connect(
    state => {
        const { createRequest, translation } = state;
        return {
            createRequest
            , ...translation
        };
    }
    , dispatch =>
        bindActionCreators(
            Object.assign({}, newCircuitExhibitBActions
                , createRequestActions
                , fileAttachmentActions
            ),
            dispatch
        )
)(NewCircuitFormExhibitB);